module.exports = __webpack_public_path__ + "static/media/ambrussum_strassenstation.83bd7547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/ambrussum_strassenstation.png
// module id = 699
// module chunks = 0